export default (props, vars) => props?.['name'] === 'reviews';
